module.exports = __webpack_public_path__ + "img/yuexiugongyuan.32102616.png";